import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { FaMinus, FaPlus } from 'react-icons/fa';

import './Counter.css';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const Counter = ({
    initialValue,
    label,
    onChange,
    searchKey,
    lowestValue = 0,
    maxValue = null,
}) => {
    const [count, setCount] = useState(initialValue);
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const handleIncrement = () => {
        setCount((prevCount) => {
            const updatedCount = prevCount + 1;
            if (maxValue === null || updatedCount <= maxValue) {
                return updatedCount;
            } else {
                if (maxValue && updatedCount > maxValue) {
                    toast.error(Lang?.youHaveReachedTheMaximunQuantity, {
                        autoClose: true,
                        theme: 'colored',
                        PlacementType: 'top-left',
                    });
                }
                return prevCount;
            }
        });
    };
    const handleDecrement = () => {
        setCount((prevCount) =>
            prevCount - 1 < lowestValue ? lowestValue : prevCount - 1
        );
    };

    useEffect(() => {
        if (onChange) {
            onChange(searchKey, count);
        }
    }, [count]);

    return (
        <div className="ab-incrementor">
            <span>{label}</span>
            <div className="ab-minus-plus">
                <button
                    className=""
                    tabIndex="-1"
                    disabled=""
                    aria-label="Minus"
                    aria-disabled="true"
                    onClick={handleDecrement}
                    type="button"
                >
                    <FaMinus />
                </button>
                {/* TODO: WHAT ABOUT MIN MAX VALUES */}
                <input
                    tabIndex="0"
                    role="slider"
                    aria-valuenow="1"
                    aria-valuemin="1"
                    aria-valuemax="8"
                    value={count}
                    readOnly
                />
                <button
                    className=""
                    tabIndex="-1"
                    aria-label="Plus"
                    aria-disabled="false"
                    onClick={handleIncrement}
                    type="button"
                >
                    <FaPlus />
                </button>
            </div>
        </div>
    );
};

Counter.propTypes = {
    initialValue: PropTypes.number,
    label: PropTypes.string,
    onChange: PropTypes.func,
    searchKey: PropTypes.string,
    lowestValue: PropTypes.number,
    maxValue: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
};

export default Counter;
